<template>
  <div class="min-h-screen bg-white">
    <FeaturedBooks />

    <BestsellersSection :image-only="true" />

    <RecommendedReadsSection :image-only="true" />

    <ComingSoonSection :image-only="true" />

    <CategoriesSection />
  </div>
</template>

<script setup>
import FeaturedBooks from './FeaturedBooks.vue'
import BestsellersSection from './BestsellersSection.vue'
import RecommendedReadsSection from './RecommendedReadsSection.vue'
import ComingSoonSection from './ComingSoonSection.vue'
import CategoriesSection from './CategoriesSection.vue'
</script>

<style scoped></style>
